import { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
//@ts-expect-error no types
import AutoSaveContainer from 'ContentEditorUI/containers/AutoSaveContainer';
import { getHasContentModel } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
import { getIsAppReadyForSaving } from 'ContentEditorUI/redux/selectors/appStatusSelectors';
import { selectCurrentInstance } from 'structured-content-lib/redux/selectors/instanceEditSelectors';
import { autoSave, autoSaveDebounced, validate } from '../actions/editorSaveActions';
import { getCanSave, getSaveData } from '../selectors/saveSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const keysForHardSave = [];
const keysToReload = []; // keys that require preview reload

const AutoSave = () => {
  const [shouldSkipAutoSave, setShouldSkipAutoSave] = useState(false);
  const currentInstance = useSelector(selectCurrentInstance);
  const prevState = useRef(currentInstance);
  const dispatch = useDispatch();
  const hasContentModel = useSelector(getHasContentModel);
  const saveData = useSelector(getSaveData);
  const isAppReadyForSaving = useSelector(getIsAppReadyForSaving);
  const canSave = useSelector(getCanSave);

  // The below effect is needed to check the diff between the previous and current states to determine if we need to skip CEUI
  // autoSave or not. This only affects changes to the article language since each language variant is tied to its own unique ILP
  // meaning it will need its own previewUrl for the inpage editor.
  useEffect(() => {
    if (prevState.current && currentInstance) {
      if (prevState.current['values']['hs_language'] !== currentInstance['values']['hs_language']) {
        setShouldSkipAutoSave(true);
      }
    }
  }, [currentInstance, setShouldSkipAutoSave]);
  if (!isAppReadyForSaving || !hasContentModel) {
    return null;
  }
  const handleAutoSave = shouldSkipAutoSave ? Promise.resolve({}) : () => dispatch(autoSave());
  return /*#__PURE__*/_jsx(AutoSaveContainer, {
    autoSaveDebounced: () => dispatch(autoSaveDebounced()),
    autoSave: handleAutoSave,
    saveData: saveData,
    canSave: canSave,
    keysForHardSave: keysForHardSave,
    keysToReload: keysToReload,
    validate: () => dispatch(validate())
  });
};
export default AutoSave;